export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const FIELD_EXTRA = {
  FIELD_EMPTY: {
    field: "FIELD_EMPTY",
  },
};

export const LIST_DATA_USE_RADIO_FIELD = [
  {
    value: 1,
    label: "Sử dụng",
  },
  {
    value: 0,
    label: "Không sử dụng",
  },
];

export const LIST_DATA_APPLY_RADIO_FIELD = [
  {
    value: 1,
    label: "Áp dụng",
  },
  {
    value: 0,
    label: "Không áp dụng",
  },
];

export const TAX_DEDUCT_COMMON_FIELD = {
  MSO: {
    field: "mso",
    type: "text",
    defaultValue: "01/ĐKTĐ-CTĐT",
    disabled: true,
    styleInput: {
      border: "none",
    },
    widthLabel: "158px",
  },
  TEN: {
    field: "ten",
    type: "text",
    defaultValue: "Tờ khai đăng ký/thay đổi thông tin sử dụng chứng từ điện tử",
    disabled: true,
    widthLabel: "158px",
    styleInput: {
      border: "none",
    },
  },
  HTHUC: {
    field: "hthuc",
    type: "select",
    selectValues: {
      ADD: 1,
      EDIT: 2,
    },
    max: 1,
    widthLabel: "158px",
    required: true,
  },
  TNNT: {
    field: "tnnt", // Tên NTT
    type: "text",
    required: true,
    max: 50,
    widthLabel: "158px",
  },
  MST: {
    field: "mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
    widthLabel: "158px",
    required: true,
  },
  CQTQLY: {
    field: "cqtqly",
    type: "select",
    widthLabel: "158px",
    max: 100,
    required: true,
    allowCreate: true,
  },
  MCQTQLY: {
    field: "mcqtqly",
    widthLabel: "158px",
    type: "text",
    required: true,
    max: 5,
  },
  NLHE: {
    field: "nlhe",
    type: "text",
    required: true,
    max: 50,
    widthLabel: "158px",
  },
  DCLHE: {
    field: "dchi",
    type: "text",
    required: true,
    max: 400,
    widthLabel: "158px",
  },
  DCTDTU: {
    field: "dctdtu",
    type: "text",
    required: true,
    max: 50,
    widthLabel: "158px",
  },
  DTLHE: {
    field: "sdthoai",
    type: "text",
    required: true,
    max: 20,
    widthLabel: "158px",
  },
  DDANH: {
    field: "ddanh",
    type: "text",
    required: true,
    max: 50,
    widthLabel: "158px",
  },
  NLAP: {
    field: "nlap",
    required: true,
    type: "date",
    disabled: true,
    widthLabel: "158px",
    styleInput: {
      border: "none",
    },
  },
};

export const TAX_DEDUCT_CONTENT_FIELD = {
  // Đối tượng phát hành
  DTPHANH: {
    // Tổ chức, cá nhân phát hành
    TCCNPHANH: {
      field: "tccnphanh",
      type: "radioField",
      listData: LIST_DATA_APPLY_RADIO_FIELD,
      defaultValue: 0,
    },
    // Cơ quan thuế phát hành
    CQTPHanh: {
      field: "cqtphanh",
      type: "radioField",
      listData: LIST_DATA_APPLY_RADIO_FIELD,
      defaultValue: 0,
    },
  },

  // Loại hình sử dụng
  LHSDUNG: {
    //Chứng từ điện tử khấu trừ
    CTTNCNHAN: {
      field: "cttncnhan",
      type: "radioField",
      listData: LIST_DATA_USE_RADIO_FIELD,
      defaultValue: 0,
    },
    // Chứng từ khấu trừ thuế thương mại điện tử
    CTKTTTMDTU: {
      field: "ctktttmdtu",
      type: "radioField",
      listData: LIST_DATA_USE_RADIO_FIELD,
      defaultValue: 0,
    },
    // Biên lai thu thuế, phí, lệ phí không in sẵn mệnh giá
    BLTPLPKIN: {
      field: "bltplpkin",
      type: "radioField",
      listData: LIST_DATA_USE_RADIO_FIELD,
      defaultValue: 0,
    },
    // Biên lai thu thuế, phí, lệ phí in sẵn mệnh giá
    BLTPLPIN: {
      field: "bltplpin",
      type: "radioField",
      listData: LIST_DATA_USE_RADIO_FIELD,
      defaultValue: 0,
    },
    // Biên lai thu thuế, phí, lệ phí (CTT50)
    BLTTPLPHI: {
      field: "blttplphi",
      type: "radioField",
      listData: LIST_DATA_USE_RADIO_FIELD,
      defaultValue: 0,
    },
  },

  // Hình thức gửi dữ liệu
  HTGDLCTDT: {
    // Trên Cổng thông tin điện tử của cơ quan thuế
    CDLQCCQT: {
      field: "cdlqccqt",
      type: "radioField",
      listData: LIST_DATA_APPLY_RADIO_FIELD,
      defaultValue: 0,
    },
    // Chuyển dữ liệu qua TCTN
    CDLQTCTN: {
      field: "cdlqtctn",
      type: "radioField",
      listData: LIST_DATA_APPLY_RADIO_FIELD,
      defaultValue: 0,
    },
    // Chuyển dữ liệu qua TCTN được ủy thác
    CDLQTCTNUT: {
      field: "cdlqtctnut",
      type: "radioField",
      listData: LIST_DATA_APPLY_RADIO_FIELD,
      defaultValue: 0,
    },
  },
};

// Danh sách chứng thư số sử dụng:
export const TAX_DEDUCT_DSCTSSDUNG_FIELD = {
  DSCTSSDUNG_LIST: {
    field: "listCAs",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    TTCHUC: {
      field: "ttchuc",
      type: "text",
      required: true,
      max: 400,
    },
    SERI: {
      field: "seri",
      required: true,
      type: "text",
      max: 40,
      isUnique: true,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: true,
    },
    HTHUC: {
      field: "hthuc",
      required: true,
      type: "select",
      max: 1,
      selectValues: {
        ADD: 1, // thêm mới
        EXTEND: 2, // gia hạn
        STOP_USE: 3, //ngừng sử dụng
      },
    },
  },
};

export const KHMCTU_DEFAULT = "03/TNCN";

// Đăng ký ủy nhiệm lập biên lai
export const TAX_DEDUCT_DSDKUNHIEM_FIELD = {
  DSDKUNHIEM_LIST: {
    field: "dsdkunhiem",
    STT: {
      field: "stt",
      type: "number",
      isHide: true,
    },
    LDKUNhiem: {
      field: "ldkunhiem",
      type: "select",
      required: true,
    },
    TLCTU: {
      field: "tlctu",
      type: "text",
      required: true,
      max: 100,
    },
    KHMCTU: {
      field: "khmctu",
      type: "text",
      isDisable: true,
      max: 7,
    },
    KHCTU: {
      field: "khctu",
      type: "text",
      required: true,
      max: 6,
    },
    MST: {
      field: "mst",
      type: "text",
      required: true,
      max: 14,
      isTaxCode: true,
    },
    TTCHUC: {
      field: "ttchuc",
      type: "text",
      required: true,
      max: 400,
    },
    MDICH: {
      field: "mdich",
      type: "text",
      required: true,
      max: 255,
    },
    TNGAY: {
      field: "tngay",
      required: true,
      width: "300px",
      type: "date",
    },
    DNGAY: {
      field: "dngay",
      required: true,
    },
    PTHUC: {
      field: "pthuc",
      required: true,
      type: "text",
      max: 50,
    },
  },
};
